import React, { useState, useEffect, useRef } from "react";
import { getField, getTable } from "../../../Services/tooltipService";
import _ from "lodash";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import Loader from "../../../Components/UiComponents/Loader";
import DropdownElement from "../../../Components/UiComponents/DropdownElement";
import { getByYear, saveUpdate } from "../../../Services/benchmarkingService";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import { get } from "../../../Services/customerServices";
import InputTextElementElement from "../../../Components/UiComponents/InputTextElement";
import CheckboxElement from "../../../Components/UiComponents/CheckboxElement";
import { useBenchmarking } from "../../../Providers/BenchmarkingContext";
import { useNavigate } from "react-router-dom";

const Benchmarking = () => {
    const [loading, setLoading] = useState(false);
    const [benchmarkingPlanFieldsNew, setBenchmarkingPlanFieldsNew] = useState([]);
    const [benchmarkingHeaders, setBenchmarkingHeaders] = useState([]);
    const [benchmarkingTable, setBenchmarkingTable] = useState([]);
    const [years, setYears] = useState([{ label: '2012', year: 2012 }]);
    const [selectedYearStatus, setSelectedYearStatus] = useState(false);
    const [benchData, setBenchData] = useState([]);
    const [headerFName, setHeaderFName] = useState('Forecast');
    const [businessUnit, setBusinessUnit] = useState([]);
    const [services, setServices] = useState([]);
    const [sector, setSector] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [checkDups, setCheckDups] = useState({});
    const [currency, setCurrency] = useState('');
    const [colTotals, setColTotals] = useState(new Array(9).fill(0));
    const navigate = useNavigate()
    const { globalBenchmarkingData, setGlobalBenchmarkingData } = useBenchmarking();

    const toastRef = useRef();
    var enduser = localStorage.getItem("enduser")
	if (enduser) {
		var tmpData = JSON.parse(enduser);
		if (tmpData === null) {
            navigate("/login")
            localStorage.clear()
        }
	}

    var userPrivileges = localStorage.getItem("user_privileges")
	if (userPrivileges) {
		var tmpPrivilege = JSON.parse(userPrivileges);
        if (tmpPrivilege !== undefined && tmpPrivilege !== null) {
            var benchmarkingPrevillege = tmpPrivilege[0].benchmarking;
        }
	}

    var currentDate = new Date();
    var yearDate = new Date(currentDate).getFullYear();
    const [currentYear, setCurrentYear] = useState({ label: yearDate.toString(), year: yearDate });

    useEffect(() => {
        initialgetFields()
        yearInc((yearDate - years[0].year) + 7)
        loadByYear(yearDate)
        initialgetTables()
        getCustomerDetails()
    }, [])

    useEffect(() => {
        if (checkDups.field) {
            checkForDups(checkDups.index, checkDups.value)
        }
    }, [checkDups])

    useEffect(() => {
        updateTotals();
    }, [benchData]);

    useEffect(() => {
        if (benchData && currentYear) {
            var benchmarkingData = {};
            if (selectedYearStatus == true) {
                benchmarkingData.year = currentYear.year
            } else {
                benchmarkingData.year = currentYear.year
            }

            benchmarkingData.customer_id = tmpData.customer;
            benchmarkingData.budget = benchData;
            setGlobalBenchmarkingData(benchmarkingData)
        }
    }, [benchData, currentYear]);

    const getColumnTotal = (selector) => {
        let total = 0;
        if (selector == 1) {
            for (var i = 0; i < benchData.length; i++) {
                if (benchData[i].benchmark) {
                    var temp = (benchData[i].benchmark) ? benchData[i].benchmark : 0;
                    total = total + parseFloat(temp);
                }
            }
        }
        return total;
    };

    const updateTotals = () => {
        const updatedColTotals = new Array(9).fill(0);
        for (let i = 1; i <= 1; i++) {
            updatedColTotals[i] = getColumnTotal(i);
        }
        setColTotals(updatedColTotals);
    };

    const checkForDups = (index, dropdown) => {
        var updatedBenchData = [...benchData]
        var record = updatedBenchData[index];
        var firstIndex = _.findIndex(updatedBenchData, { questions: record.questions, business_unit: record.business_unit, sector: record.sector, service: record.service });
        var lastIndex = _.findLastIndex(updatedBenchData, { questions: record.questions, business_unit: record.business_unit, sector: record.sector, service: record.service });
        if (firstIndex != lastIndex) {
            if (dropdown == 'questions') {
                updatedBenchData[index].questions = '';
            } else if (dropdown == 'business_unit') {
                updatedBenchData[index].business_unit = '';
            } else if (dropdown == 'sector') {
                updatedBenchData[index].sector = '';
            } else if (dropdown == 'service') {
                updatedBenchData[index].service = '';
            }
            toastRef.current.showToast({
                type: 'error',
                message: "Duplicate Record"
            });
            setBenchData(updatedBenchData)
        }
    }

    const getCustomerDetails = async () => {
        try {
            if (tmpData.customer === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true);
            var customerData = await get(tmpData.customer)
            if(customerData && customerData.data){
            var currencyData = (!_.isUndefined(customerData.data.currency)) ? customerData.data.currency : '£';
            setCurrency(currencyData)
            var referenceData = customerData.data.reference_data;
            referenceData.forEach((item) => {
                if (item.option_names === "BusinessUnit") {
                    setBusinessUnit(item.option_choice.filter((option) => option.status === 'active'));
                } else if (item.option_names === "SectorV1") {
                    setSector(item.option_choice.filter((option) => option.status === 'active'));
                } else if (item.option_names === "Services") {
                    setServices(item.option_choice.filter((option) => option.status === 'active'));
                }
            });
            var rdsData = customerData.data.rds_data;
            var questions = [];
            for (var i = 0; i < rdsData.length; i++) {
                questions.push({ label: rdsData[i].display_name });
            }
            setQuestions(questions)
        }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    }

    const initialgetFields = async () => {
        try {
            if (tmpData.customer === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true);

            var fieldData = await getField(tmpData.customer)
            if (fieldData && fieldData.data) {
                var clientModuleData = fieldData.data;
                var benchmarkingPlanModules = _.find(clientModuleData.cust[0].modules, { module_name: "Benchmarking", status: true });
                var benchmarkingPlanFieldsNew = _.find(benchmarkingPlanModules.sub_modules, { sub_module_name: "Benchmarking" }).fields;
                setBenchmarkingPlanFieldsNew(benchmarkingPlanFieldsNew);
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    }

    const initialgetTables = async () => {
        try {
            if (tmpData.customer === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true);
            var fieldData = await getTable(tmpData.customer)
            if (fieldData && fieldData.data) {
                var benchmarkingModuleDataTables = fieldData.data;
                var benchmarkingFieldsTable = _.find(benchmarkingModuleDataTables.cust[0].modules, { module_name: "Benchmarking", status: true });
                var benchmarkingTable = _.find(benchmarkingFieldsTable.sub_modules, { sub_module_name: "Benchmarking" }).tables;
                setBenchmarkingTable(benchmarkingTable);
                var benchmarkingHeaders = _.find(benchmarkingTable, { table_name: "ESG Budget & ROI Plan" }).headers;
                setBenchmarkingHeaders(benchmarkingHeaders);
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    }

    const yearInc = (limit) => {
        for (var i = 1; i <= limit; i++) {
            var lastVal = years[years.length - 1];
            var strVal = (lastVal.year + 1).toString();
            years.push({ label: strVal, year: lastVal.year + 1 });
            setYears(years)
        }
    }

    const loadByYear = async (year) => {
        try {
            if (tmpData.customer === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true)
            var entity = [];
            var benchData = await getByYear(tmpData.customer, year)
            if (benchData && benchData.data) {
                var af = year < yearDate ? 'Actual' : 'Forecast';
                setHeaderFName(af)
                if (benchData.data && benchData.data.length > 0) {
                    var entity = benchData.data[0].budget;
                    setBenchData(entity)
                } else {
                    setBenchData([])
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    };

    const captureChange = (selectedYear) => {
        loadByYear(selectedYear.year);
        setCurrentYear(selectedYear)
        setSelectedYearStatus(true)
    }

    const deleteSelected = () => {
        var selectedId = ''
        benchData.forEach((action) => {
            if (action?.checked) {
                selectedId = action._id
            }
        });

        setBenchData(prevState =>
            prevState.filter(row => row._id !== selectedId)
        );
    }

    const generateRandomID = () => {
        const hexChars = '0123456789abcdef';
        let result = '';
        for (let i = 0; i < 24; i++) {
            result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
        }
        return result;
    }

    const addNew = () => {
        const newRow = {
            _id: generateRandomID(),
            questions: "",
            business_unit: "",
            sector: "",
            service: "",
            benchmark: ""
        };
        setBenchData(prevState => ([
            ...prevState,
            newRow
        ]));
    }

    const selectedElement = (index, e) => {
        setBenchData(prevState =>
            prevState.map((item, i) =>
                i === index ? { ...item, checked: e } : item
            )
        );
    };

    const saveBenchUpdate = async () => {
        try {
            if (tmpData.customer === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true)
            var inavalidRecords = [];
            var validRecords = [];
            benchData.filter(function (row) {
                if (row.business_unit == undefined && row.sector == undefined && row.service == undefined && row.questions == undefined) {
                    inavalidRecords.push(row);
                }
            });
            benchData.filter(function (row) {
                if (row.business_unit != undefined || row.sector != undefined || row.service != undefined || row.questions != undefined) {
                    validRecords.push(row);
                }
            });

            inavalidRecords.filter(function (record) {
                _.remove(benchData, record);
            });

            var benchmarkingData = {};
            if (selectedYearStatus == true) {
                benchmarkingData.year = currentYear.year
            } else {
                benchmarkingData.year = currentYear.year
            }

            benchmarkingData.customer_id = tmpData.customer;
            benchmarkingData.budget = benchData;
            var benchSave = await saveUpdate(tmpData.customer, benchmarkingData)
            if (benchSave && benchSave.data) {
                toastRef.current.showToast({
                    type: 'success',
                    message: "Benchmarking Info Updated Successfully"
                });
                loadByYear(currentYear.year)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="mt-20">
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="form-group row align-items-center mb-0">
                <div className="col-md-10 pl-0">
                    <div className="form-group row align-items-center mb-0 mt-0 w-30">
                        <div className="col-md-6 pl-0">
                            <label className="form-label text-left">{_.find(benchmarkingPlanFieldsNew, { field_name: "Plan Year" })?.display_name}</label>
                        </div>
                        <div className="col pr-0">
                            <DropdownElement
                                value={currentYear}
                                onChange={(e) => captureChange(e.value)}
                                options={(years != undefined && years.length > 0) ? years : []}
                                optionLabel="label"
                                placeholder="-- Please select --"
                                className="w-full"
                            />
                        </div>
                    </div>
                </div>
                {
                    _.find(benchmarkingTable, { table_name: "ESG Budget & ROI Plan" })?.status &&
                    <div className="col pr-0 d-flex justify-end">
                        <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={deleteSelected} disabled={!benchmarkingPrevillege} />
                        <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addNew} disabled={!benchmarkingPrevillege} />
                    </div>
                }
            </div>
            {
                _.find(benchmarkingTable, { table_name: "ESG Budget & ROI Plan" })?.status &&
                <>
                    <div className="group-table-data mt-10">
                        <table className="group-datatable activity budget-plan">
                            <thead className="group-table-header">
                                <tr>
                                    <th colSpan={6}>{headerFName + ' - ' + _.find(benchmarkingTable, { table_name: "ESG Budget & ROI Plan" })?.display_name}</th>
                                </tr>
                                <tr>
                                    <th className="checkbox-header width-2"></th>
                                    <th className="w-20">{_.find(benchmarkingHeaders, { header_name: "Stakeholder ESG Maturity Question" })?.display_name}</th>
                                    <th className="w-20">{_.find(benchmarkingHeaders, { header_name: "Business Unit" })?.display_name}</th>
                                    <th className="w-20">{_.find(benchmarkingHeaders, { header_name: "Sector" })?.display_name}</th>
                                    <th className="w-20">{_.find(benchmarkingHeaders, { header_name: "Services" })?.display_name}</th>
                                    <th>{_.find(benchmarkingHeaders, { header_name: "Benchmark" })?.display_name}</th>
                                </tr>
                            </thead>
                            <tbody className="group-table-row">
                                {
                                    benchData.length > 0 && benchData?.map((item, index) => {
                                        const matched = (questions != undefined && questions.length > 0) ? questions.find((i) => i.label === item.questions) : '';
                                        const matched1 = (businessUnit != undefined && businessUnit.length > 0) ? businessUnit.find((i) => i.label === item.business_unit) : '';
                                        const matched2 = (sector != undefined && sector.length > 0) ? sector.find((i) => i.label === item.sector) : '';
                                        const matched3 = (services != undefined && services.length > 0) ? services.find((i) => i.label === item.service) : '';
                                        return (
                                            <React.Fragment>
                                                <tr>
                                                    <td className="width-2">
                                                        <CheckboxElement
                                                            id={`plan-${index}`}
                                                            name={`plan-${index}`}
                                                            checked={item.checked}
                                                            onChangeCheck={(e) => { selectedElement(index, e.target.checked) }}
                                                            className="mr-2"
                                                            disabled={!benchmarkingPrevillege}
                                                        />
                                                    </td>
                                                    <td className="w-20">
                                                        <DropdownElement
                                                            value={matched ? matched : null}
                                                            onChange={(e) => {
                                                                setBenchData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? { ...item, questions: e.value.label }
                                                                            : item
                                                                    )
                                                                );
                                                                setCheckDups({
                                                                    field: true,
                                                                    index: index,
                                                                    value: 'questions'
                                                                })
                                                            }}
                                                            options={(questions != undefined && questions.length > 0) ? questions : []}
                                                            optionLabel="label"
                                                            placeholder="-- Please select --"
                                                            className="w-full"
                                                            disabled={!benchmarkingPrevillege}
                                                        />
                                                    </td>
                                                    <td className="w-20">
                                                        <DropdownElement
                                                            value={matched1 ? matched1 : null}
                                                            onChange={(e) => {
                                                                setBenchData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? { ...item, business_unit: e.value.label }
                                                                            : item
                                                                    )
                                                                );
                                                                setCheckDups({
                                                                    field: true,
                                                                    index: index,
                                                                    value: 'business_unit'
                                                                })
                                                            }}
                                                            options={(businessUnit != undefined && businessUnit.length > 0) ? businessUnit : []}
                                                            optionLabel="label"
                                                            placeholder="-- Please select --"
                                                            className="w-full"
                                                            disabled={!benchmarkingPrevillege}
                                                        />
                                                    </td>
                                                    <td className="w-20">
                                                        <DropdownElement
                                                            value={matched2 ? matched2 : null}
                                                            onChange={(e) => {
                                                                setBenchData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? { ...item, sector: e.value.label }
                                                                            : item
                                                                    )
                                                                );
                                                                setCheckDups({
                                                                    field: true,
                                                                    index: index,
                                                                    value: 'sector'
                                                                })
                                                            }}
                                                            options={(sector != undefined && sector.length > 0) ? sector : []}
                                                            optionLabel="label"
                                                            placeholder="-- Please select --"
                                                            className="w-full"
                                                            disabled={!benchmarkingPrevillege}
                                                        />
                                                    </td>
                                                    <td className="w-20">
                                                        <DropdownElement
                                                            value={matched3 ? matched3 : null}
                                                            onChange={(e) => {
                                                                setBenchData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? { ...item, service: e.value.label }
                                                                            : item
                                                                    )
                                                                );
                                                                setCheckDups({
                                                                    field: true,
                                                                    index: index,
                                                                    value: 'service'
                                                                })
                                                            }}
                                                            options={(services != undefined && services.length > 0) ? services : []}
                                                            optionLabel="label"
                                                            placeholder="-- Please select --"
                                                            className="w-full"
                                                            disabled={!benchmarkingPrevillege}
                                                        />
                                                    </td>
                                                    <td>
                                                        <InputTextElementElement
                                                            className="dropdown-field-handle"
                                                            value={item.benchmark}
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                setBenchData(prevState =>
                                                                    prevState.map((item, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...item, benchmark: e.target.value
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            }}
                                                            disabled={!benchmarkingPrevillege}
                                                        />
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        );
                                    })
                                }
                            </tbody>
                            <thead className="group-table-header">
                                <tr>
                                    <th className="checkbox-header" colSpan={4}></th>
                                    <th className="w-20">{_.find(benchmarkingHeaders, { header_name: "Quarterly Total" })?.display_name + ' (' + currency + ')'}</th>
                                    <th className="width-5">{colTotals[1]}</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div className="col pr-0 d-flex justify-end">
                        <ButtonElement className="save-button" type="submit" onClick={saveBenchUpdate} label="Save" disabled={!benchmarkingPrevillege} />
                    </div>
                </>
            }
        </div>
    );
}

export default Benchmarking